import React from 'react';
import { injectIntl } from 'react-intl';
import { inject, observer } from 'mobx-react';
import ReactJoyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import Button from '../../components/common/Button';
import IconSvg from '../../components/common/IconSvg';
import Tooltip from '../../components/OnboardingWizardTooltip';
import { test_flow } from '../../components/OnboardingScreens/flows';
import eNums from '../../constants/enums';

const BeaconComponent = () => (
  <span
    css={css`
      position: absolute;
      bottom: 3rem;
      right: 0;
      z-index:999;
    `}
  />
);

@injectIntl
@inject('onboardingStore')
@inject('settingsStore')
@observer
class Wizard extends React.Component {
  handleJoyrideCallback = data => {
    const { onboardingStore } = this.props;
    if (!onboardingStore.storeInitialized) {
      return;
    }

    const { action, index, type, status } = data;
    let wizardStepIndex = index;

    if (STATUS.FINISHED === status) {
      onboardingStore.finishWizard();
      onboardingStore.congratulate();
    } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      wizardStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
      onboardingStore.setWizardStep(wizardStepIndex);
    }
  };

  render() {
    const {
      runWizard,
      wizardStepIndex,
      flow,
      storeInitialized,
      wizardDone,
      toggleTriggerMaximize,
      toggleWizard,
    } = this.props.onboardingStore;
    const { currentPlanId } = this.props.settingsStore.subscription;
    const { registeredForCourse } = this.props.settingsStore.userProfile;

    let loadedFlow;
    switch (flow) {
      default:
        loadedFlow = test_flow;
        break;
    }

    if(registeredForCourse){
      loadedFlow=test_flow;
    }

    if (wizardDone) {
      return null;
    }

    return (
      <div id="onboarding-wizard" style={{zIndex:'999'}}>
        <Button
          clickHandler={() => {
            if (currentPlanId === eNums.SUBSCRIPTION_PLANS.FREE_TRAIL) {
              return;
            }
            toggleTriggerMaximize();
            toggleWizard();
          }}
          css={css`
            position: fixed;
            right: 1rem;
            bottom: 5.5rem;
            border: 0;
            padding: 0;
            z-index: 101;
          `}
          type="ghost"
        >
          <IconSvg size={40} type="onboarding-min" />
        </Button>
        {storeInitialized ? (
          <ReactJoyride
            beaconComponent={BeaconComponent}
            tooltipComponent={Tooltip}
            steps={loadedFlow.steps}
            stepIndex={wizardStepIndex}
            run={runWizard}
            continuous
            disableCloseOnEsc
            disableOverlayClose
            callback={this.handleJoyrideCallback}
          />
        ) : null}
      </div>
    );
  }
}

Wizard.propTypes = {
  onboardingStore: PropTypes.object,
};

Wizard.defaultProps = {};

export default Wizard;
